import { combineReducers } from 'redux';

import { mainReducer } from 'pages/MainPage/store';

export const rootReducer = combineReducers({
  main: mainReducer,
});

